export const KID_THEMES = {
  sunset: {
    id: 'sunset',
    name: 'Sunset',
    emoji: '🌈',
    description: 'Bright pink, purple, and sunset colors.',
    backgroundClass:
      'bg-gradient-to-br from-purple-400 via-pink-500 to-red-500',
    availableCardClass:
      'bg-gradient-to-br from-green-400 to-green-600',
    savingsCardClass:
      'bg-gradient-to-br from-blue-400 to-blue-600',
    headerPillClass:
      'bg-purple-50 border-purple-200',
    headerLabelClass: 'text-purple-700',
    headerAmountClass: 'text-purple-900',
    headerInfoClass:
      'border-purple-400 text-purple-700 hover:bg-purple-100 focus:ring-purple-300',
    accentButtonClass:
      'bg-gradient-to-r from-purple-500 to-pink-500',
  },

  ocean: {
    id: 'ocean',
    name: 'Ocean',
    emoji: '🌊',
    description: 'Cool blue, aqua, and ocean colors.',
    backgroundClass:
      'bg-gradient-to-br from-cyan-400 via-blue-500 to-indigo-600',
    availableCardClass:
      'bg-gradient-to-br from-emerald-400 to-teal-600',
    savingsCardClass:
      'bg-gradient-to-br from-sky-400 to-blue-700',
    headerPillClass:
      'bg-sky-50 border-sky-200',
    headerLabelClass: 'text-sky-700',
    headerAmountClass: 'text-sky-900',
    headerInfoClass:
      'border-sky-400 text-sky-700 hover:bg-sky-100 focus:ring-sky-300',
    accentButtonClass:
      'bg-gradient-to-r from-cyan-500 to-blue-600',
  },

  adventure: {
    id: 'adventure',
    name: 'Adventure',
    emoji: '🌿',
    description: 'Fresh green, teal, and outdoor colors.',
    backgroundClass:
      'bg-gradient-to-br from-lime-400 via-emerald-500 to-teal-600',
    availableCardClass:
      'bg-gradient-to-br from-green-500 to-emerald-700',
    savingsCardClass:
      'bg-gradient-to-br from-teal-400 to-cyan-700',
    headerPillClass:
      'bg-emerald-50 border-emerald-200',
    headerLabelClass: 'text-emerald-700',
    headerAmountClass: 'text-emerald-900',
    headerInfoClass:
      'border-emerald-400 text-emerald-700 hover:bg-emerald-100 focus:ring-emerald-300',
    accentButtonClass:
      'bg-gradient-to-r from-emerald-500 to-teal-600',
  },

  galaxy: {
    id: 'galaxy',
    name: 'Galaxy',
    emoji: '🌌',
    description: 'Deep indigo, violet, and space colors.',
    backgroundClass:
      'bg-gradient-to-br from-indigo-700 via-purple-700 to-fuchsia-700',
    availableCardClass:
      'bg-gradient-to-br from-violet-500 to-purple-700',
    savingsCardClass:
      'bg-gradient-to-br from-indigo-500 to-blue-700',
    headerPillClass:
      'bg-indigo-50 border-indigo-200',
    headerLabelClass: 'text-indigo-700',
    headerAmountClass: 'text-indigo-900',
    headerInfoClass:
      'border-indigo-400 text-indigo-700 hover:bg-indigo-100 focus:ring-indigo-300',
    accentButtonClass:
      'bg-gradient-to-r from-indigo-600 to-fuchsia-600',
  },
};

export const KID_THEME_LIST = Object.values(KID_THEMES);

export const getKidTheme = (themeId) =>
  KID_THEMES[themeId] || KID_THEMES.sunset;
